/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import Pago from '../../components/Pago'
import Footer from '../../components/Footer'
import Header from '../../components/Header'
import GeneralContext from '../../context/GeneralContext'
import styles from './PrimerPago.module.css'
import * as GeneralActions from '../../store/actions/generalActions'
import * as PrimerPagoRepository from '../../services/repositories/primer-pago-repository'

const PrimerPago = ({ history }) => {
    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected || prospecto.completado)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    const initialState = {
        estaCargando: true,
        errorCargando: null,
        reloadValidacion: false
    }

    const [objSoles, setObjSoles] = useState(null)
    const [objDolares, setObjDolares] = useState(null)
    const [statusPayments, setStatusPayments] = useState([])
    const [isDisabled, setIsDisabled] = useState(true)
    const [state, setState] = useState(initialState)

    const getUsdData = (product, status) => {
        const arrUSD = product.filter((obj) => obj.moneda === 'Dolares')
        const amount = arrUSD.reduce((acc, curr) => acc + curr.primaTotal, 0)
        const currency = '$'
        const currencyID = 'USD'
        const description = arrUSD.map((p) => p.nombreProducto).join(",")
        const id = arrUSD.map(e => e.idSolicitud)
        const payed = status.some((e) => id.includes(e.idSolicitud))
        let obj = {}

        if (payed) {
            obj = status.find((e) => e.idSolicitud === id[0])
        }

        function calculateCodigoSafetyPay(obj) {
            return obj.cobranzaPrimeraCuota.codigo === 8 ? obj : false
        }

        function calculateVisa(obj) {
            return obj.cobranzaPrimeraCuota.codigo === 9 && !obj.esPagoLink ? obj : false
        }

        //Verificacion si primer pago fue por pago link
        function calculatePagoLink(obj) {
            return obj.esPagoLink
        }

        return {
            amount,
            currency,
            currencyID,
            description,
            id,
            payed: payed ? calculateCodigoSafetyPay(obj) : false,
            payedVisa: payed ? calculateVisa(obj) : false,
            payedPagolink: calculatePagoLink(obj),
            codMoneda: currency === 'S/' ? 2 : 1
        }
    }

    const getPenData = (product, status) => {
        const arrPEN = product.filter((obj) => obj.moneda === 'Soles')
        const amount = arrPEN.reduce((acc, curr) => acc + curr.primaTotal, 0)
        const currency = 'S/'
        const currencyID = 'PEN'
        const description = arrPEN.map((p) => p.nombreProducto).join(",")
        const id = arrPEN.map(e => e.idSolicitud)
        const payed = status.some((e) => id.includes(e.idSolicitud))
        let obj = {}

        if (payed) {
            obj = status.find((e) => e.idSolicitud === id[0])
        }

        function calculateCodigoSafetyPay(obj) {
            return obj.cobranzaPrimeraCuota.codigo === 8 ? obj : false
        }

        function calculateVisa(obj) {
            return obj.cobranzaPrimeraCuota.codigo === 9 && !obj.esPagoLink ? obj : false
        }

        //Verificacion si primer pago fue por pago link
        function calculatePagoLink(obj) {
            return obj.esPagoLink
        }

        return {
            amount,
            currency,
            currencyID,
            description,
            id,
            payed: payed ? calculateCodigoSafetyPay(obj) : false,
            payedVisa: payed ? calculateVisa(obj) : false,
            payedPagolink: calculatePagoLink(obj),
            codMoneda: currency === 'S/' ? 2 : 1
        }
    }

    const cargarDatosIniciales = async () => {
        generalDispatch(GeneralActions.updateEstadoCargando(true))
        await getListPayments()
    }

    const getListPayments = async () => {
        const response = await PrimerPagoRepository.obtenerListaPagos(cotizacion.idSolicitudMultiple)
        if (response.error === null) {
            let product = response.listaPagos.productos
            getPaymentsSolicitud(product)
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
        }
    }

    const getPaymentsSolicitud = async (producto) => {
        const response = await PrimerPagoRepository.obtenerPagosSolicitud(cotizacion.idSolicitudMultiple)
        if (response.error === null) {
            const usd = getUsdData(producto, response.pagos)
            const pen = getPenData(producto, response.pagos)
            setStatusPayments(response.pagos)
            setObjDolares(usd)
            setObjSoles(pen)
            generalDispatch(GeneralActions.updateEstadoCargando(false))
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
        }
    }

    useEffect(() => {
        cargarDatosIniciales()
    }, [])

    const validarPantalla = () => {
        if (isDisabled) return false
        return true
        // setear y dejar pasar
    }

    const onPayment = (obj, safetypay, visap, pagoLink) => {
        //CMUNAYLLA: se agrega la logica para poder diferenciar la data de visa y safetypay
        //si selecciono niubiz, entonces, visa es true y safety es false;
        //lo mismo para el caso de safetypay, visa es false y safety es true
        //se deberia agregar uno mas para el caso de pagoLink
        let visa = visap
        let safety = safetypay
        let pagolink = pagoLink
        if (obj.currency === '$') {
            setObjDolares((state) => {
                return {
                    ...state,
                    payed: safety ? obj : false,
                    payedVisa: visa ? obj : false,
                    payedPagolink: pagolink ? obj : false
                }
            })
        } else {
            setObjSoles((state) => {
                return {
                    ...state,
                    payed: safety ? obj : false,
                    payedVisa: visa ? obj : false,
                    payedPagolink: pagolink ? obj : false
                }
            })
        }
    }

    useEffect(() => {
        //validaciones para habilitar el boton de continuar
        if (objSoles?.amount > 0 && objDolares?.amount > 0) {
            if ((objSoles?.payedVisa && objDolares?.payedVisa) || (objSoles?.payed && objDolares?.payed)
                || (objSoles?.payed && objDolares?.payedVisa) || (objSoles?.payedVisa && objDolares?.payed)
                || (objSoles?.payedPagolink && objDolares?.payedPagolink) || (objSoles?.payedVisa && objDolares?.payedPagolink)
                || (objSoles?.payedPagolink && objDolares?.payedVisa) || (objSoles?.payed && objDolares?.payedPagolink)
                || (objSoles?.payedPagolink && objDolares?.payed)) {
                setIsDisabled(false)
            }
        } else if (objSoles?.amount > 0 || objDolares?.amount > 0) {
            if (objSoles?.payedVisa || objSoles?.payed || objSoles?.payedPagolink ||
                objDolares?.payedVisa || objDolares?.payed || objDolares?.payedPagolink) {
                setIsDisabled(false)
            }
        }
    }, [objSoles, objDolares])

    return (
        <React.Fragment>
            <Header history={history} valor={cotizacion.requisitosIniciales !== undefined
                && cotizacion.requisitosIniciales} />
            <section className={styles['areadatosusuario']}>
                <h1 className={styles['titulopago']}>Hagamos el primer pago de tu solicitud</h1>
                {objSoles?.amount > 0
                    ? <Pago data={objSoles} onPayment={onPayment} payment={statusPayments} state={state} setState={setState} id="first" /> : ''}
                {objDolares?.amount > 0
                    ? <Pago data={objDolares} onPayment={onPayment} payment={statusPayments} state={state} setState={setState} id="first" /> : ''}
                <Footer disabled={isDisabled} validarPantalla={validarPantalla} history={history} />
            </section>
        </React.Fragment>
    )
}

export default PrimerPago;